import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sticky from 'Components/Sticky';
import { Link } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import Heading from 'Components/Heading';
import Tabs from 'Components/Tabs';
import ActionLoader from 'Components/ActionLoader';
import { GET_GOOGLE_STUDIO_REPORT } from 'Constants/actionConstants';
import { getUser } from 'Utils/storage';

const TABS = [
    {value: 'Contract Monitoring Dashboard', id: 1, report_id: '6f7f1693574c4ec2ac54ed35aa50c6da996'},
    {value: 'PTPK Analysis', id: 2, report_id: '6f7f1693574c4ec2ac54ed35aa50c6da9912'},
    {value: 'Bidding Analysis', id: 3, report_id: '6f7f1693574c4ec2ac54ed35aa50c6da9913'},
    {value: ' Pricing Analysis', id: 4, report_id: '6f7f1693574c4ec2ac54ed35aa50c6da9914'},
    // {value: 'Indent vs Placement Dashboard', id: 5, report_id: '6f7f1693574c4ec2ac54ed35aa50c6da997'},
    // {value: 'VIVO Dashboard', id: 6, report_id: '6f7f1693574c4ec2ac54ed35aa50c6da998'},
    // {value: 'In-Transit Dashboard', id: 7, report_id: '6f7f1693574c4ec2ac54ed35aa50c6da999'},
    // {value: 'Transporter Appraisal Scorecard', id: 8, report_id: '6f7f1693574c4ec2ac54ed35aa50c6da9911'},
    // {value: 'Executive Summary Dashboard', id: 5, report_id: '6f7f1693574c4ec2ac54ed35aa50c6da9910'}
]

class Dashboard extends Component{
    constructor(props){
        super(props);
        this.state={
            selectedTab: 1,
            reportId: '6f7f1693574c4ec2ac54ed35aa50c6da996',
            isLoading: true
        }
    }
    
    componentDidMount() {
        const user = getUser();
        if(user.isDepotUser || user.isHOUser) {
            TABS.splice(1, 0, { value: 'Depot Contracting Dashboard', id: 5, report_id: '6f7f1693574c4ec2ac54ed35aa50c6da9923'})
        }
        this.getReport();
    }

    selectTab = (id) => {
        const reportId = ((TABS || []).find(el => el.id === id) || {}).report_id;
        this.setState({ selectedTab: id, reportId, isLoading: true }, this.getReport);
    }

    getReport = () => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_GOOGLE_STUDIO_REPORT,
            params: {
                report_id: this.state.reportId
            }
        })
    }

    render(){
        const { selectedTab, isLoading } = this.state;
        const { data } = this.props;
        return(
            <Sticky>
                <div className="pl-20 pr-20 pt-20 pb-20">
                    <Link to="/seeker">
                        <BackIcon className="fill-theme curP mr-5 fBolder"/>
                        {'Back'}
                    </Link>
                    <Heading type="medium" text="Dashboards" className="mt-10 text-center" />
                    <div className="mt-10 ph-10 mb-10">
                        <Tabs key={1} selectTab={(id) => this.selectTab(id)} activeTabId={selectedTab} tabs={TABS} isBold={false}/>
                    </div>
                    {isLoading && <ActionLoader fixed={true}/>}
                    {data.report_id && <iframe
                        src={data.src}
                        style={{width: "100%", height: 760}}
                        frameBorder="0"
                        onLoad={() => { this.setState({ isLoading: false }) }}
                        title={data.report_name}
                        allowFullScreen
                    />}
                </div>
            </Sticky>
        )
    }    
}

const mapStateToProps = ({constants}) => {
    return {
      data: constants.googleStudioReport || {}
    }
  };

export default connect(mapStateToProps)(Dashboard);